<template>
<!-- FINAL MEMBER -->
  <form @submit.prevent>
     <CModal
        :title.sync="title"
        color="info"
        size="lg"
        :show.sync="show">
        <CRow>
          <CCol lg="6">  
            <strong > Personal Information</strong>
          </CCol>
        </CRow>          
            <CRow class="mt-3" >
              <CCol >
              <b-input v-model="form.firstname" placeholder='First name' :state="validationFirstname" id="feedback-user" class="mb-1"> </b-input>
              <b-form-invalid-feedback :state="validationFirstname">
              Your firstname must be filled
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validationFirstname">
              Looks Good.
              </b-form-valid-feedback>
              </CCol>
              <CCol >
              <b-input v-model="form.lastname" placeholder='Last name' :state="validationLastname" id="feedback-user" class="mb-1"> </b-input>
              <b-form-invalid-feedback :state="validationLastname">
              Your lastname must be filled
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validationLastname">
              Looks Good.
              </b-form-valid-feedback>
              </CCol>
            </CRow>
            <CRow class="mt-2">
              <CCol >
                <CInput v-model="form.alias"  placeholder='Nickname' />
              </CCol>
       
              <CCol>
                 <CInput  v-model="form.dob"  type='date' /> 
              </CCol>
            </CRow>
            <strong > Contact Information </strong>
             <CRow class="mt-3"    >
              
              <CCol >
                <CInput v-model="form.phone" placeholder='Phone Number' type="number" step="1" min="0" @keydown="filterKey" @input="filterInput" class="mb-1" />
              </CCol>
              <CCol >
                 <CInput v-model="form.mobile_phone" placeholder='Mobile Phone' type="number" step="1" min="0" @keydown="filterKey" @input="filterInput" class="mb-1" />
              </CCol>
            </CRow>
            <CRow class="mt-2">
              <CCol :col="6">
                <b-input v-model="form.email" placeholder='Last name' :state="validationEmail" id="feedback-user" class="mb-1"> </b-input>
              <b-form-invalid-feedback :state="validationEmail">
              Example : testemail@yahoo.com
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="validationEmail">
              Looks Good.
              </b-form-valid-feedback></CCol>
            </CRow>
            <strong > Address Information </strong>
             <CRow class="mt-3">
              <CCol>
                <CInput v-model="form.address1"   placeholder='Address 1' />
              </CCol>
            </CRow>
             <CRow class="mt-0"    >
              <CCol >
                <CInput v-model="form.city"  placeholder='City' class="mb-1" />
              </CCol>
              <CCol >
                 <CInput v-model="form.state"  placeholder='State/Province' class="mb-1" />
              </CCol>
            </CRow>
            <CRow class="mt-2">
              <CCol :col="number">
                <CInput v-model="form.country"   placeholder='Country' />
              </CCol>
        
              <CCol :col=" number">
                 <CInput v-model="form.zipcode"  placeholder='ZipCode' />
              </CCol>
            </CRow>
            <CRow >
              <CCol >
                <CInput v-model="form.address2"   placeholder='Address 2' />
              </CCol>
            </CRow>
          <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  @click="show = false, showModal= true"  variant="outline" color="info">Next</CButton>
      </template>
    </CModal>
     <CModal
         :title.sync="title"
        color="info"
        size="lg"
        :show.sync="showModal">
        <strong > Additional Information </strong>
        <CRow>
          <CCol lg="6">
            <CInput label="First Time Visiting Church" type="date" class="mt-3" />
            <CInput v-model="form.previous_church" label="Previous Church" placeholder='First name'  />
            <label> is Covenant ? </label>
            <c-input-checkbox
              label="Mark this member as covenant" class="mb-3"
            />
            <CInput v-model="form.covenant_date" label="Covenant Date" type="date"  />
            <CInput v-model="form.covenant_certificate" label="Covenant Certificate No." placeholder='Certificate No.' class="mb-3" />
            <CInput v-model="form.baptism_date" label="Baptism Date" type="date"  />
           
          </CCol>
          <CCol lg="6" class="mb-4" >
            
            <CInput label="First Time Visiting iCare" type="date" class="mt-3" />
            <label> is Married ? </label>
            <c-input-checkbox
              label="Mark this member as married" class="mb-3"
            />
            <CInput v-model="form.marriage_date"  label="Marriage Date" type="date"  />
            <CInput label="Marriage Church" placeholder='Marriage Church' class="mb-3" />
            <CInput label="Marriage Certificate No." placeholder='Certificate No.' class="mb-3" />
            <CInput label="Baptism Certificate No." placeholder='Certificate No.' class="mb-3" />
            <label> Satellite Church </label>
            <b-form-select
                v-model="form.satellite_church_id"
                :options= "options"
            >
              </b-form-select>
          </CCol>
        </CRow> 
        <template #footer>
        <CButton @click="showModal = false,show= true" color="danger">Back</CButton>
        <CButton  v-if="mode === 'create'" type="submit" v-on:click.prevent="create()"  variant="outline" color="info">Create</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="update(form.uuid)"  variant="outline" color="info">Update</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';
import member from '@/services/member';
import satelite from '@/services/satelitechurch'
import icare from '@/services/icare'
import moment from 'moment';


export default {
name: 'membermodal',

  data () {
    return {
      show: false,
      showModal: false,
      title: 'Default Title',
      mode: '',
      form:{
        uuid: '',
        id:'',
        firstname: '',
        lastname: '',
        alias:'',
        email:'',
        dob: '',
        address1:'',
        address2:'',
        city:'',
        state:'',
        country:'',
        zipcode:'',
        previous_church:'',
        baptism_date:'',
        marriage_date:'',
        covenant_certificate:'',
        covenant_date:'',
        mobile_phone:'',
        phone:'',
        moment:'',  
        satellite_church_id:''
       
      },

      options:[],
      largeModal:false,
      largeModal1:false,
      
    }
    
  },
  computed: {
      validationFirstname() {
        return this.form.firstname.length > 0 
      },
       validationLastname() {
        return this.form.lastname.length > 0
      },
       validationEmail() {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(this.form.email)) {
          return true;
      }
      return false;
      },
    },
  
  mounted(){
  },
  created () {
    var self = this;
      EventBus.$on('OPEN_MODAL_MEMBER', (params) => {
      if(params.data){
      member.getMemberbyID(params.data)
      .then(res => {
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = params.data;
      self.form.firstname = res.data.firstname;
      self.form.lastname = res.data.lastname;
      self.form.dob = res.data.dob;
      self.form.alias = res.data.alias;
      self.form.email = res.data.email;
      self.form.address1 = res.data.address1;
      self.form.address2 = res.data.address2;
      self.form.phone = res.data.phone;
      self.form.mobile_phone = res.data.mobile_phone;
      self.form.satellite_church_id = res.data.satellite_church_id;
      self.form.city = res.data.city;
      self.form.state = res.data.state;
      self.form.country = res.data.country;
      self.form.marriage_date = res.data.marriage_date;
      self.form.zipcode = res.data.zipcode;
      self.form.covenant_date = res.data.covenant_date;
      self.form.covenant_certificate = res.data.covenant_certificate;
      self.form.baptism_date = res.data.baptism_date;
      self.form.previous_church = res.data.previous_church;

       }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
         }else{
      self.show = true;
      self.title = params.title;
      self.mode = params.mode;
      self.form.uuid = "";
      self.form.firstname = "";
      self.form.lastname = "";
      self.form.dob = "";
      self.form.alias = "";
      self.form.email = "";
      self.form.address1 = "";
      self.form.address2 = "";
      self.form.phone = "";
      self.form.mobile_phone = "";
      self.form.satellite_church_id = "";
      self.form.city = "";
      self.form.state = "";
      self.form.country = "";
      self.form.marriage_date = "";
      self.form.zipcode = "";
      self.form.covenant_date = "";
      self.form.covenant_certificate ="";
      self.form.baptism_date = "";
      self.form.previous_church = "";
      }
      
    });
     satelite.getSateliteChurch()
      .then(res => {
        for (let i=0; i <= res.data.length; i++){
          //alert
          this.options.push({text: res.data[i].name, value:res.data[i].id})
        }
      }).catch((er) =>{
        
      })
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    create(){
      this.show = false;
      this.showModal= false,
      this.form.dob  = moment(this.form.dob).format ('DD/MM/YYYY')
      if( this.form.covenant_date == null ){
        this.form.covenant_date  == '' 
        
      } 
      else{
         this.form.covenant_date= moment(this.form.covenant_date).format ('DD/MM/YYYY') ; 
      }
      if( this.form.baptism_date == null ){
        this.form.baptism_date  == '' 
        
      } 
      else{
          this.form.baptism_date=   moment(this.form.baptism_date).format ('DD/MM/YYYY') ;
      }

      if( this.form.marriage_date == null ){
        this.form.marriage_date  == ''
       
      } 
      else{
         this.form.marriage_date =  moment(this.form.marriage_date).format ('DD/MM/YYYY') 
      }
      
      member.createMember(this.form)
      .then(res => {
        EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    filterKey(e){
      const key = e.key;

      // If is '.' key, stop it
      if (key === '.')
        return e.preventDefault();
      
      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e')
        return e.preventDefault();
    },
    
    // This can also prevent copy + paste invalid character
    filterInput(e){
      e.target.value = e.target.value.replace(/[^0-9]+/g, '');
    },

    update(id){
      this.show = false;
      member.updateMember(id, this.form)
      .then(res => {
        EventBus.$emit('PAGE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },  
   
  }
}
</script>

<style>

</style>